@file:OptIn(InternalResourceApi::class)

package qytqwasm.apps.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/qytqwasm.apps.generated.resources/"

@delegate:ResourceContentHash(35_966_901)
internal val Res.drawable.appsicon: DrawableResource by lazy {
      DrawableResource("drawable:appsicon", setOf(
        ResourceItem(setOf(), "${MD}drawable/appsicon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-460_624_856)
internal val Res.drawable.backicon: DrawableResource by lazy {
      DrawableResource("drawable:backicon", setOf(
        ResourceItem(setOf(), "${MD}drawable/backicon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_183_446_124)
internal val Res.drawable.directed: DrawableResource by lazy {
      DrawableResource("drawable:directed", setOf(
        ResourceItem(setOf(), "${MD}drawable/directed.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(826_991_894)
internal val Res.drawable.foreicon: DrawableResource by lazy {
      DrawableResource("drawable:foreicon", setOf(
        ResourceItem(setOf(), "${MD}drawable/foreicon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-890_944_419)
internal val Res.drawable.iconadds: DrawableResource by lazy {
      DrawableResource("drawable:iconadds", setOf(
        ResourceItem(setOf(), "${MD}drawable/iconadds.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_221_888_602)
internal val Res.drawable.iconfind: DrawableResource by lazy {
      DrawableResource("drawable:iconfind", setOf(
        ResourceItem(setOf(), "${MD}drawable/iconfind.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_876_517_608)
internal val Res.drawable.iconinfo: DrawableResource by lazy {
      DrawableResource("drawable:iconinfo", setOf(
        ResourceItem(setOf(), "${MD}drawable/iconinfo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(741_814_927)
internal val Res.drawable.iconkill: DrawableResource by lazy {
      DrawableResource("drawable:iconkill", setOf(
        ResourceItem(setOf(), "${MD}drawable/iconkill.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-44_691_234)
internal val Res.drawable.iconmove: DrawableResource by lazy {
      DrawableResource("drawable:iconmove", setOf(
        ResourceItem(setOf(), "${MD}drawable/iconmove.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(96_049_142)
internal val Res.drawable.iconopts: DrawableResource by lazy {
      DrawableResource("drawable:iconopts", setOf(
        ResourceItem(setOf(), "${MD}drawable/iconopts.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_519_405_308)
internal val Res.drawable.iconrest: DrawableResource by lazy {
      DrawableResource("drawable:iconrest", setOf(
        ResourceItem(setOf(), "${MD}drawable/iconrest.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-755_122_412)
internal val Res.drawable.iconsets: DrawableResource by lazy {
      DrawableResource("drawable:iconsets", setOf(
        ResourceItem(setOf(), "${MD}drawable/iconsets.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_213_932_868)
internal val Res.drawable.iconsite: DrawableResource by lazy {
      DrawableResource("drawable:iconsite", setOf(
        ResourceItem(setOf(), "${MD}drawable/iconsite.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(420_075_673)
internal val Res.drawable.iconsuns: DrawableResource by lazy {
      DrawableResource("drawable:iconsuns", setOf(
        ResourceItem(setOf(), "${MD}drawable/iconsuns.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(827_881_686)
internal val Res.drawable.iconwarn: DrawableResource by lazy {
      DrawableResource("drawable:iconwarn", setOf(
        ResourceItem(setOf(), "${MD}drawable/iconwarn.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_059_895_636)
internal val Res.drawable.location: DrawableResource by lazy {
      DrawableResource("drawable:location", setOf(
        ResourceItem(setOf(), "${MD}drawable/location.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_022_733_637)
internal val Res.drawable.qybx: DrawableResource by lazy {
      DrawableResource("drawable:qybx", setOf(
        ResourceItem(setOf(), "${MD}drawable/qybx.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-842_318_001)
internal val Res.drawable.qyby: DrawableResource by lazy {
      DrawableResource("drawable:qyby", setOf(
        ResourceItem(setOf(), "${MD}drawable/qyby.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_299_917_332)
internal val Res.drawable.qydf: DrawableResource by lazy {
      DrawableResource("drawable:qydf", setOf(
        ResourceItem(setOf(), "${MD}drawable/qydf.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(266_681_405)
internal val Res.drawable.qydx: DrawableResource by lazy {
      DrawableResource("drawable:qydx", setOf(
        ResourceItem(setOf(), "${MD}drawable/qydx.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_628_300_360)
internal val Res.drawable.qydy: DrawableResource by lazy {
      DrawableResource("drawable:qydy", setOf(
        ResourceItem(setOf(), "${MD}drawable/qydy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_072_207_677)
internal val Res.drawable.qyfc: DrawableResource by lazy {
      DrawableResource("drawable:qyfc", setOf(
        ResourceItem(setOf(), "${MD}drawable/qyfc.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(124_615_131)
internal val Res.drawable.qyqr: DrawableResource by lazy {
      DrawableResource("drawable:qyqr", setOf(
        ResourceItem(setOf(), "${MD}drawable/qyqr.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-379_786_766)
internal val Res.drawable.qyqy: DrawableResource by lazy {
      DrawableResource("drawable:qyqy", setOf(
        ResourceItem(setOf(), "${MD}drawable/qyqy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_678_973_068)
internal val Res.drawable.qywm: DrawableResource by lazy {
      DrawableResource("drawable:qywm", setOf(
        ResourceItem(setOf(), "${MD}drawable/qywm.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-878_869_561)
internal val Res.drawable.qywz: DrawableResource by lazy {
      DrawableResource("drawable:qywz", setOf(
        ResourceItem(setOf(), "${MD}drawable/qywz.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_523_067_642)
internal val Res.drawable.qyxx: DrawableResource by lazy {
      DrawableResource("drawable:qyxx", setOf(
        ResourceItem(setOf(), "${MD}drawable/qyxx.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-521_684_711)
internal val Res.drawable.qyxy: DrawableResource by lazy {
      DrawableResource("drawable:qyxy", setOf(
        ResourceItem(setOf(), "${MD}drawable/qyxy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_204_112_190)
internal val Res.drawable.qyyr: DrawableResource by lazy {
      DrawableResource("drawable:qyyr", setOf(
        ResourceItem(setOf(), "${MD}drawable/qyyr.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(515_707_771)
internal val Res.drawable.qyys: DrawableResource by lazy {
      DrawableResource("drawable:qyys", setOf(
        ResourceItem(setOf(), "${MD}drawable/qyys.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_134_548_017)
internal val Res.drawable.qyyt: DrawableResource by lazy {
      DrawableResource("drawable:qyyt", setOf(
        ResourceItem(setOf(), "${MD}drawable/qyyt.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_452_984_045)
internal val Res.drawable.qyyw: DrawableResource by lazy {
      DrawableResource("drawable:qyyw", setOf(
        ResourceItem(setOf(), "${MD}drawable/qyyw.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_039_464_369)
internal val Res.drawable.qyyy: DrawableResource by lazy {
      DrawableResource("drawable:qyyy", setOf(
        ResourceItem(setOf(), "${MD}drawable/qyyy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(979_438_189)
internal val Res.drawable.qyzx: DrawableResource by lazy {
      DrawableResource("drawable:qyzx", setOf(
        ResourceItem(setOf(), "${MD}drawable/qyzx.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-952_163_559)
internal val Res.drawable.qyzy: DrawableResource by lazy {
      DrawableResource("drawable:qyzy", setOf(
        ResourceItem(setOf(), "${MD}drawable/qyzy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_802_081_217)
internal val Res.drawable.selected: DrawableResource by lazy {
      DrawableResource("drawable:selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/selected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_109_260_705)
internal val Res.drawable.selectee: DrawableResource by lazy {
      DrawableResource("drawable:selectee", setOf(
        ResourceItem(setOf(), "${MD}drawable/selectee.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-626_087_480)
internal val Res.drawable.shzscoat: DrawableResource by lazy {
      DrawableResource("drawable:shzscoat", setOf(
        ResourceItem(setOf(), "${MD}drawable/shzscoat.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_139_451_000)
internal val Res.drawable.shzsdrug: DrawableResource by lazy {
      DrawableResource("drawable:shzsdrug", setOf(
        ResourceItem(setOf(), "${MD}drawable/shzsdrug.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(891_891_385)
internal val Res.drawable.shzsheat: DrawableResource by lazy {
      DrawableResource("drawable:shzsheat", setOf(
        ResourceItem(setOf(), "${MD}drawable/shzsheat.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_013_774_901)
internal val Res.drawable.shzsrays: DrawableResource by lazy {
      DrawableResource("drawable:shzsrays", setOf(
        ResourceItem(setOf(), "${MD}drawable/shzsrays.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_621_325_103)
internal val Res.drawable.sstqdamp: DrawableResource by lazy {
      DrawableResource("drawable:sstqdamp", setOf(
        ResourceItem(setOf(), "${MD}drawable/sstqdamp.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_063_659_671)
internal val Res.drawable.sstqheat: DrawableResource by lazy {
      DrawableResource("drawable:sstqheat", setOf(
        ResourceItem(setOf(), "${MD}drawable/sstqheat.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_280_212_296)
internal val Res.drawable.sstqrain: DrawableResource by lazy {
      DrawableResource("drawable:sstqrain", setOf(
        ResourceItem(setOf(), "${MD}drawable/sstqrain.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(564_150_972)
internal val Res.drawable.sstqsees: DrawableResource by lazy {
      DrawableResource("drawable:sstqsees", setOf(
        ResourceItem(setOf(), "${MD}drawable/sstqsees.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_954_196_042)
internal val Res.drawable.sstqwind: DrawableResource by lazy {
      DrawableResource("drawable:sstqwind", setOf(
        ResourceItem(setOf(), "${MD}drawable/sstqwind.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-518_361_161)
internal val Res.drawable.sunsdrop: DrawableResource by lazy {
      DrawableResource("drawable:sunsdrop", setOf(
        ResourceItem(setOf(), "${MD}drawable/sunsdrop.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-330_821_022)
internal val Res.drawable.sunsrise: DrawableResource by lazy {
      DrawableResource("drawable:sunsrise", setOf(
        ResourceItem(setOf(), "${MD}drawable/sunsrise.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectWebMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("appsicon", Res.drawable.appsicon)
  map.put("backicon", Res.drawable.backicon)
  map.put("directed", Res.drawable.directed)
  map.put("foreicon", Res.drawable.foreicon)
  map.put("iconadds", Res.drawable.iconadds)
  map.put("iconfind", Res.drawable.iconfind)
  map.put("iconinfo", Res.drawable.iconinfo)
  map.put("iconkill", Res.drawable.iconkill)
  map.put("iconmove", Res.drawable.iconmove)
  map.put("iconopts", Res.drawable.iconopts)
  map.put("iconrest", Res.drawable.iconrest)
  map.put("iconsets", Res.drawable.iconsets)
  map.put("iconsite", Res.drawable.iconsite)
  map.put("iconsuns", Res.drawable.iconsuns)
  map.put("iconwarn", Res.drawable.iconwarn)
  map.put("location", Res.drawable.location)
  map.put("qybx", Res.drawable.qybx)
  map.put("qyby", Res.drawable.qyby)
  map.put("qydf", Res.drawable.qydf)
  map.put("qydx", Res.drawable.qydx)
  map.put("qydy", Res.drawable.qydy)
  map.put("qyfc", Res.drawable.qyfc)
  map.put("qyqr", Res.drawable.qyqr)
  map.put("qyqy", Res.drawable.qyqy)
  map.put("qywm", Res.drawable.qywm)
  map.put("qywz", Res.drawable.qywz)
  map.put("qyxx", Res.drawable.qyxx)
  map.put("qyxy", Res.drawable.qyxy)
  map.put("qyyr", Res.drawable.qyyr)
  map.put("qyys", Res.drawable.qyys)
  map.put("qyyt", Res.drawable.qyyt)
  map.put("qyyw", Res.drawable.qyyw)
  map.put("qyyy", Res.drawable.qyyy)
  map.put("qyzx", Res.drawable.qyzx)
  map.put("qyzy", Res.drawable.qyzy)
  map.put("selected", Res.drawable.selected)
  map.put("selectee", Res.drawable.selectee)
  map.put("shzscoat", Res.drawable.shzscoat)
  map.put("shzsdrug", Res.drawable.shzsdrug)
  map.put("shzsheat", Res.drawable.shzsheat)
  map.put("shzsrays", Res.drawable.shzsrays)
  map.put("sstqdamp", Res.drawable.sstqdamp)
  map.put("sstqheat", Res.drawable.sstqheat)
  map.put("sstqrain", Res.drawable.sstqrain)
  map.put("sstqsees", Res.drawable.sstqsees)
  map.put("sstqwind", Res.drawable.sstqwind)
  map.put("sunsdrop", Res.drawable.sunsdrop)
  map.put("sunsrise", Res.drawable.sunsrise)
}
